<div data-toggle="buttons">
    <label class="btn btn-info-button w100" [class.active]="active()">
        <input type="radio" [disabled]="enabled() ? undefined : true" [value]="item()" [ngModel]="selectedItem()" (ngModelChange)="onSelect()">
        <div class="flex">
            <span class="flex-grow" [title]="title()">{{ title() }}</span>
            <button type="button" title="close" class="btn btn-sm pull-right" [disabled]="!enabled()" (click)="onClose()">&times;</button>
        </div>
        <span class="hr"></span>
        <ng-content></ng-content>
    </label>
</div>
